import styled from 'styled-components';
import { TextField } from '@mui/material';

import {
    getColor,
    getFontFamily,
    getFontSize,
    getLetterSpacing, getLineHeight,
} from '@process-advisor/process-miner/shared/theme';

export const StyledTextField = styled(TextField)`
    width: 60px;
    margin-right: 5px;

    & .MuiInputBase-root {
        background-color: ${getColor('white')};
        border: 1px solid ${getColor('lightBorderColor')};
        border-radius: 8px;

        &:hover {
            border-color: ${getColor('blue')};
        }
    }

    & .MuiInputBase-root.Mui-disabled {
        background-color: ${getColor('lightGray')};

        &:hover {
            border-color: ${getColor('lightBorderColor')};
        }
    }

    & input {
        text-align: center;
        color: ${getColor('inputTextColor')};
        font-family: ${getFontFamily('atlassian')};
        font-size: ${getFontSize('smaller')};
        letter-spacing: ${getLetterSpacing('input')};
        line-height: ${getLineHeight('small')};
        padding: 5px;
    }
    & fieldset,
    & fieldset:hover {
        border: none;
    }
    & legend {
        border-bottom: none !important;
    }
`;

